import { Constants } from "@eagerdog/constants";
import { IEventRegisterRow } from "../../../services/helper.service.js";

export namespace AKCTrickDog {
  export const form: IEventRegisterRow[] = [
    {
      allowDuplicates: false,
      inputs: [
        {
          type: "checkbox",
          label: Constants.dog_class_element.trick_dog,
          multiSelect: true,
          multiLevelWarning: "If you enter more than one Trick Dog level on the same day, each higher level depends on passing the one before it. If your dog does not pass a lower level, higher-level entries will not be valid.",
          options: [
            {
              value: Constants.dog_class_element_level.tkn,
              id: Constants.dog_class_element_level.tkn,
            },
            {
              value: Constants.dog_class_element_level.tki,
              id: Constants.dog_class_element_level.tki,
            },
            {
              value: Constants.dog_class_element_level.tka,
              id: Constants.dog_class_element_level.tka,
            },
            {
              value: Constants.dog_class_element_level.tkp,
              id: Constants.dog_class_element_level.tkp,
            },
            {
              value: Constants.dog_class_element_level.tke,
              id: Constants.dog_class_element_level.tke,
            },
          ],
        },
      ],
    },
  ];
}
